const wowApp = require('angular').module('oly.common');

const { formValidationSummaryComponentDefinition } = require('./form-validation-summary.component');

wowApp.component('olyFormValidationSummary', formValidationSummaryComponentDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/form-validation-summary/index.js